<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <p class="primary--text mb-2 font-weight-bold">
          Filtrar
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="pr-md-5 pr-0">
        <BaseSelect
          placeholder="Tipos de Filtros"
          :items="listTypesFilter"
          v-model="quotationFilter.tipo"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-md-5 pr-0">
        <BaseFilter
          v-model="quotationFilter.valor"
          :textPlaceholder="'Informe'"
          hide-no-data
          item-text="nome"
          item-value="id"
          validate-on-blur
          :return-object="true"
          required
          :rules="[requiredInput]"
        />
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="6" md="2" class="pr-0 pb-5 pb-md-0 pr-sm-3">
        <BaseButton
          v-html="'PESQUISAR'"
          class="secondary white--text"
          width="100%"
          @click="searchByFilter"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pb-5 pb-md-0">
        <BaseButton
          v-html="'LIMPAR'"
          color="secondary"
          width="100%"
          outlined
          @click="resetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="header"
          :items="listQuotationAgro"
          no-data-text="Nenhuma Cotação foi encontrada"
          loading-text="Carregando Cotações..."
          :options.sync="options"
          :server-items-length="totalQuotation"
          class="quotationTableAgro base__datatable"
          @click:row="redirectToQuotation"
          :footer-props="{ 'items-per-page-options': [25, 50, 100, 250, 500] }"
        >
          <template v-slot:[`item.numero`]="{ item }">
            <div class="quotationTableAgro__padding">
              {{ item.numero }}
            </div>
          </template>
          <template v-slot:[`item.status.nome`]="{ item }">
            <div :class="borderColor(item.status)">
              <div class="quotationTableAgro__padding">
                {{ item.status.nome }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.criada_em`]="{ item }">
            <div class="quotationTableAgro__padding">
              {{ formatIsoDateToDDMMYYYY(item.criada_em) }}
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
const tableHeaders = [
  { text: "N° da Solicitação", value: "numero", sortable: false },
  { text: "Canal", value: "canal", sortable: false },
  { text: "Data", value: "criada_em", sortable: false },
  { text: "Segurado", value: "segurado.nome", sortable: false },
  { text: "CPF/CNPJ", value: "segurado.numero_documento", sortable: false },
  { text: "Produto", value: "produto", sortable: false },
  { text: "Cultura", value: "submodalidade.nome", sortable: false },
  { text: "Status", value: "status.nome", sortable: false },
  { text: "Dias no status", value: "dias_status", sortable: false }
];
const colorByStatus = [
  { color: "pink", status: "cancelada" },
  { color: "green", status: "aguardando_confirmacao_usuario" },
  { color: "green", status: "aguardando_cotacao" },
  { color: "yellow", status: "aguardando_aprovacao_cotacao" },
  { color: "yellow", status: "aguardando_dados_segurado" },
  { color: "yellow", status: "aguardando_dados_risco" },
  { color: "purple", status: "aguardando_proposta" },
  { color: "purple", status: "aguardando_conformidade" },
  { color: "purple", status: "aguardando_emissao_apolice" },
  { color: "blue", status: "proposta_emitida" },
  { color: "light-blue", status: "apolice_emitida" }
];
const DEFAULT_STATUS = { color: "yellow" };
const MOCK_FILTER = {
  valor: null,
  tipo: {
    nome: null,
    id: null
  },
  filter: null,
  inicio: null,
  fim: null
};
const MOCK_TYPES_FILTER = [
  {
    nome: "Segurado",
    id: "segurado"
  },
  {
    nome: "CPF/CNPJ",
    id: "numero_documento"
  },
  {
    nome: "Número Solicitação",
    id: "numero"
  },
  {
    nome: "Status",
    id: "status"
  },
  {
    nome: "Canal",
    id: "grupo_economico"
  },
  {
    nome: "Produto",
    id: "modalidades"
  },
  {
    nome: "Cultura",
    id: "submodalidades"
  },
  {
    nome: "Seguradora",
    id: "seguradoras"
  }
  // {
  //   nome: "Início de Vigência",
  //   id: "inicio_vigencia"
  // },
  // {
  //   nome: "Término de Vigência",
  //   id: "fim_vigencia"
  // }
];

import { formatIsoDateToDDMMYYYY } from "@/utils/formats.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { maskDate } from "@/utils/masks.js";
import _ from "lodash";
import { dateTermValid, requiredInput } from "@/utils/rules.js";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import { defaultFilterOptions } from "@/mixins/PayloadDataTableMixin";
export default {
  data() {
    return {
      quotationFilter: null,
      currentFilter: null,
      listTypesFilter: MOCK_TYPES_FILTER,
      header: tableHeaders,
      listColorByStatus: colorByStatus,
      options: defaultFilterOptions(),
      maskDate,
      timeout: null,
      dateTermValid,
      formatIsoDateToDDMMYYYY,
      initializeFilter: false,
      currentTab: 1,
      requiredInput
    };
  },
  watch: {
    options: {
      handler(value) {
        this.fetchQuotationAgro(this.getPayload(value));
      },
      deep: true
    },
    "quotationFilter.tipo"() {
      // Toda vez que trocar o filtro, tem que resertar o valor antigo
      if (this.initializeFilter) return;
      this.quotationFilter.valor = null;
      this.resetCurrentFilters();
    }
  },
  mixins: [LoadingRequest, CommonPayload],
  created() {
    this.initialize();
  },
  computed: {
    ...mapState("quotation", [
      "listQuotationAgro",
      "totalQuotation",
      "currentAutoCompleteFilterQuotation",
      "currentTakerQuotation",
      "currentSelectFilterQuotation"
    ]),
    ...mapState(["nameOptionsDataTable", "filterDataTable"])
  },
  methods: {
    ...mapActions("quotation", [
      "requestListQuotationAgro",
      "resetCurrentFilters"
    ]),
    initialize() {
      this.updateOptionsAccordingTabView(this.currentTab);
      this.initializeFilter = true;
      this.quotationFilter =
        this.nameOptionsDataTable == this.$route.name &&
        _.isObject(this.filterDataTable)
          ? this.filterDataTable
          : _.cloneDeep(MOCK_FILTER);
      this.searchByFilter();
      this.initializeFilter = false;
    },
    fetchQuotationAgro(payload) {
      this.withLoading(this.requestListQuotationAgro(payload));
    },
    validateFilterTaker() {
      return (
        !this.quotationFilter.filter || Boolean(this.quotationFilter.filter?.id)
      );
    },
    validate() {
      const validateForm = this.quotationFilter.tipo.id
        ? this.$refs.form.validate()
        : true;
      return validateForm && this.validateFilterTaker();
    },
    searchByFilter() {
      if (!this.validate()) return;
      this.currentFilter = _.cloneDeep(this.quotationFilter);
      this.fetchQuotationAgro(this.getPayload(this.options));
    },
    resetFilter() {
      this.options = _.cloneDeep(defaultFilterOptions());
      this.quotationFilter = _.cloneDeep(MOCK_FILTER);
      this.currentFilter = _.cloneDeep(MOCK_FILTER);
      this.fetchQuotationAgro(this.getPayload(this.options));
    },
    borderColor(item) {
      const status =
        this.listColorByStatus.find(x => x.status == item.id) || DEFAULT_STATUS;
      return `quotationTableAgro__background-${status.color}`;
    },
    getFilterPayload() {
      const filterChosen =
        this.currentFilter.tipo.id == null
          ? ""
          : `&${this.currentFilter.tipo.id}=${this.currentFilter.valor}`;
      return `${filterChosen}`;
    },
    getPayload(options) {
      const { page, itemsPerPage, sortDesc, sortBy } = options;
      const directSort =
        sortBy.length == 1 ? (sortDesc[0] ? "desc" : "asc") : "desc";
      // Pegar do headers o elemento que será ordenado
      const sort = sortBy.length == 1 ? sortBy[0] : "status_alterado_em";
      return `?page=${page}&page_size=${itemsPerPage}&sort=${sort}&direction=${directSort}${this.getFilterPayload()}`;
    },
    redirectToQuotation(item) {
      this.saveOptionsDataTable(this.payloadOptions(this.currentTab));
      this.$router.push({ name: "quotation element", params: { id: item.id } });
    }
  }
};
</script>
<style lang="sass">
.quotationTableAgro__
  &label
    font-size: 14px
    font-weight: 400
    color: #676778 !important
  &padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
  &background-blue
    background-color: #8fe3ff
    border-radius: 4px
    padding-top: 10px
    padding-bottom: 10px
  &background-green
    background-color: #dcdcdc
    border-radius: 4px
    padding-top: 10px
    padding-bottom: 10px
  &background-light-blue
    background-color: #d5ffff
    border-radius: 4px
    padding-top: 10px
    padding-bottom: 10px
  &background-purple
    background-color: #fff0ff
    border-radius: 4px
    padding-top: 10px
    padding-bottom: 10px
  &background-yellow
    background-color: #ffffdc
    padding-top: 12px
    padding-bottom: 12px
    border-radius: 4px
  &background-pink
    background-color: #ff735a
    padding-top: 10px
    padding-bottom: 10px
    border-radius: 4px
.quotationTableAgro
  thead th
    font-family: 'Poppins' !important
    font-size: 14px !important
  tbody tr
    cursor: pointer
.quotationTableAgro.v-data-table.theme--light
  tbody tr td:first-child
    padding: 2px 0px !important
  tbody tr td:last-child
    padding-left: 30px !important
</style>
